module.exports = __webpack_public_path__ + "static/media/resumeThumbnail.ea02e088.webp";